import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { Link, Route, matchPath, withRouter } from 'react-router-dom';
import { Accordion, AccordionHeader } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';

import { mapIndex } from 'utilities/ramda';
import { alphabet } from 'constants/common';

const AccordionRenderer = ({ location, pages, parentPath, t }) => {
  return (
    <Accordion data-test="accordionContainer">
      {mapIndex(({ component: Component, route, title }, index) => {
        const isActive = !!matchPath(location.pathname, `${parentPath}${route}`);
        return (
          <Accordion key={route} data-test={`accordionItem-${isActive ? 'active' : 'inactive'}`}>
            <AccordionHeader
              active={isActive}
              component={Link}
              to={`${parentPath}${isActive ? '' : `${route}`}`}
            >
              {alphabet[index].toUpperCase()}. {t(title)}
            </AccordionHeader>
            <Route component={Component} path={`${parentPath}${route}`} />
          </Accordion>
        );
      }, pages)}
    </Accordion>
  );
};

AccordionRenderer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.func.isRequired,
      route: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  parentPath: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  withTranslation(),
)(AccordionRenderer);
